import React, { useEffect, useRef, useState } from "react";
import best_1 from '../../../assets/images/best_1.jpg';
import best_2 from '../../../assets/images/best_2.jpg';
import best_3 from '../../../assets/images/best_3.jpg';
import best_4 from '../../../assets/images/best_4.jpg';
import best_5 from '../../../assets/images/best_5.webp';
import best_6 from '../../../assets/images/best_6.webp';
import { gsap } from "gsap";

const BestSelling = () => {
  // Sample product images - replace with your actual product images
  const products = [
    {
      id: 1,
      name: "Insecticides",
      image: best_1,
      imageMobile: best_1,
    },
    {
      id: 2,
      name: "Fungicides",
      image: best_2,
      imageMobile: best_2,
    },
    {
      id: 3,
      name: "Herbicides",
      image: best_3,
      imageMobile: best_3,
    },
    {
      id: 4,
      name: "Plant Growth Regulators",
      image: best_4,
      imageMobile: best_4,
    },
    {
      id: 5,
      name: "Plant Growth Regulators",
      image: best_5,
      imageMobile: best_5,
    },
    {
      id: 6,
      name: "Plant Growth Regulators",
      image: best_6,
      imageMobile: best_6,
    },
    {
      id: 7,
      name: "Insecticides",
      image: best_1,
      imageMobile: best_1,
    },
    {
      id: 8,
      name: "Fungicides",
      image: best_2,
      imageMobile: best_2,
    },
    {
      id: 9,
      name: "Herbicides",
      image: best_3,
      imageMobile: best_3,
    },
    {
      id: 10,
      name: "Insecticides",
      image: best_1,
      imageMobile: best_1,
    },
    {
      id: 11,
      name: "Fungicides",
      image: best_2,
      imageMobile: best_2,
    },
    {
      id: 12,
      name: "Herbicides",
      image: best_3,
      imageMobile: best_3,
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const slidesRef = useRef([]);
  const gridRef = useRef(null);
  const gridItemsRef = useRef([]);
  const timeoutsRef = useRef([]);

  const [columns, setColumns] = React.useState("repeat(2, 1fr)");
  const [windowSize, setWindowSize] = React.useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1024,
    height: typeof window !== 'undefined' ? window.innerHeight : 768
  });

  React.useEffect(() => {
    const updateSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });

      // Update columns based on window width
      if (window.innerWidth < 640) {
        setColumns("repeat(3, 1fr)"); // mobile
      } else if (window.innerWidth < 1024) {
        setColumns("repeat(3, 1fr)"); // tablet
      } else {
        setColumns("156px 183px 183px 183px 156px"); // desktop
      }
    };

    updateSize(); // Initial call
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);


  const addToRefs = (el) => {
    if (el && !slidesRef.current.includes(el)) {
      slidesRef.current.push(el);
    }
  };

  const addToGridRefs = (el) => {
    if (el && !gridItemsRef.current.includes(el)) {
      gridItemsRef.current.push(el);
    }
  };
  // Function to navigate between slides
  const goToSlide = (direction) => {
    let newIndex;

    if (direction === 'next') {
      newIndex = (currentSlide + 1) % products.length;
    } else if (direction === 'prev') {
      newIndex = (currentSlide - 1 + products.length) % products.length;
    } else if (typeof direction === 'number') {
      newIndex = direction;
    }

    // Animate out current slide
    if (slidesRef.current[currentSlide]) {
      // Animate main slide out
      gsap.to(slidesRef.current[currentSlide], {
        opacity: 0,
        scale: 0.8,
        duration: 0.5,
        ease: "power2.inOut",
      });

      // Animate grid items
      animateGridForTransition(currentSlide, newIndex);

      const t = setTimeout(() => {
        setCurrentSlide(newIndex);
      }, 500);
      timeoutsRef.current.push(t);
    } else {
      setCurrentSlide(newIndex);
    }
  };

  // Function to animate grid items during transition
  const animateGridForTransition = (currentIdx, newIdx) => {
    if (gridItemsRef.current.length === 0) return;

    // Calculate which grid items to highlight based on the product index
    const productIndex = newIdx % products.length;
    const highlightItems = [];

    // Find grid items that match the new product index
    gridItemsRef.current.forEach((item, index) => {
      if (index % products.length === productIndex) {
        highlightItems.push(item);
      }
    });

    // First animate all grid items to fade out slightly
    gsap.to(gridItemsRef.current, {
      opacity: 0.15,
      scale: 0.92,
      filter: 'blur(2px)',
      duration: 0.4,
      stagger: {
        from: 'center',
        amount: 0.1
      },
      ease: "power2.inOut",
    });

    const t = setTimeout(() => {
      // Highlight matching grid items
      gsap.to(highlightItems, {
        opacity: 0.6,
        scale: 1,
        filter: 'blur(0px)',
        duration: 0.6,
        stagger: 0.05,
        ease: "power2.out",
      });

      // Extra highlight for the center item
      const centerIndex = Math.floor(gridItemsRef.current.length / 2);
      gsap.to(gridItemsRef.current[centerIndex], {
        opacity: 1,
        scale: 1.1,
        filter: 'blur(0px)',
        boxShadow: '0 0 20px rgba(255,255,255,0.3)',
        duration: 0.7,
        delay: 0.1,
        ease: "power2.out",
      });
    }, 200);
    timeoutsRef.current.push(t);
  };

  // GSAP animation for slide transitions
  useEffect(() => {
    if (slidesRef.current.length === 0) return;

    const ctx = gsap.context(() => {
      gsap.set(slidesRef.current, {
        opacity: 0,
        position: 'absolute',
        scale: 0.8
      });

      if (slidesRef.current[currentSlide]) {
        gsap.to(slidesRef.current[currentSlide], {
          opacity: 1,
          position: 'relative',
          scale: 1,
          duration: 0.7,
          ease: 'power2.inOut'
        });

        const currentSlideElement = slidesRef.current[currentSlide];
        const heading = currentSlideElement.querySelector('h3');
        const description = currentSlideElement.querySelector('p');

        if (heading && description) {
          gsap.fromTo(heading,
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.5, delay: 0.3 }
          );
          gsap.fromTo(description,
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.5, delay: 0.5 }
          );
        }

        if (gridItemsRef.current.length > 0) {
          gsap.set(gridItemsRef.current, {
            opacity: 0.2,
            scale: 0.95,
          });

          const centerIndex = Math.floor(gridItemsRef.current.length / 2);
          gsap.to(gridItemsRef.current[centerIndex], {
            opacity: 1,
            scale: 1.1,
            duration: 0.5,
            ease: "power2.out",
          });
        }
      }
    }, sliderRef);

    return () => ctx.revert();
  }, [currentSlide]);

  // Initialize grid animation
  useEffect(() => {
    if (gridItemsRef.current.length === 0) return;

    const productIndex = currentSlide % products.length;
    const highlightItems = [];

    gridItemsRef.current.forEach((item, index) => {
      if (index % products.length === productIndex) {
        highlightItems.push(item);
      }
    });

    const ctx = gsap.context(() => {
      gsap.fromTo(gridItemsRef.current,
        { opacity: 0, scale: 0.9, filter: 'blur(3px)' },
        {
          opacity: 0.15,
          scale: 0.92,
          filter: 'blur(2px)',
          duration: 0.7,
          stagger: {
            from: 'center',
            amount: 0.2
          },
          ease: "power2.out"
        }
      );
    }, sliderRef);

    const t = setTimeout(() => {
      gsap.to(highlightItems, {
        opacity: 0.6,
        scale: 1,
        filter: 'blur(0px)',
        duration: 0.5,
        stagger: 0.05,
        ease: "power2.out",
      });

      const centerIndex = Math.floor(gridItemsRef.current.length / 2);
      gsap.to(gridItemsRef.current[centerIndex], {
        opacity: 1,
        scale: 1.1,
        filter: 'blur(0px)',
        boxShadow: '0 0 20px rgba(255,255,255,0.3)',
        duration: 0.7,
        ease: "power2.out",
      });
    }, 500);
    timeoutsRef.current.push(t);

    return () => {
      ctx.revert();
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, []);

  return (
    <section className="max-w-[1124px] mx-auto pb-[71px] md:pb-[80px]">
      <div className="md:px-4 py-12 px-[33px]">
        <div className="mb-4 flex items-center justify-center">
          <svg
            width="24"
            height="67"
            viewBox="0 0 24 67"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="12.1222"
              y1="22.5547"
              x2="12.1222"
              y2="66.9711"
              stroke="#1C1C1C"
              strokeWidth="1.3"
            />
            <rect
              x="1.0551"
              y="0.455"
              width="22.0812"
              height="14.1485"
              rx="4.745"
              stroke="#1C1C1C"
              strokeWidth="0.91"
            />
            <circle cx="12.0957" cy="7.5293" r="3.6499" fill="#1C1C1C" />
          </svg>
        </div>

        <div className="flex flex-col items-center justify-center">
          {/* Title */}
          <h2 className="text-[28px] md:text-5xl font-[LTWave] font-medium md:font-bold mb-4 leading-tight text-center">
            Our best selling Solutions
          </h2>

          {/* Description */}
          <p className="text-gray-400 max-w-xl font-inter text-center text-[16px] ">
            Tried, tested, and trusted by thousands—our top-selling solutions
            deliver unmatched performance, reliability, and results for every
            farming need.
          </p>
        </div>
      </div>



      {/* Grid background with main slider */}
      <div
        className="relative overflow-hidden min-h-[142px] sm:min-h-[600px] md:min-h-[700px] lg:min-h-[871px] h-[543px] sm:h-[700px] md:h-[800px] lg:h-[871px]"
        ref={sliderRef}
      >
        {/* Background grid */}
        <div
          ref={gridRef}
          className="absolute inset-0 z-0 justify-center items-center h-full w-full gap-[38px] sm:gap-[50px] md:gap-[50px] lg:gap-[50px] "
          style={{
            display: "grid",
            gridTemplateColumns: columns, // col widths
            columnGap: "40px 78px 78px 40px", // custom gaps
            justifyContent: "center",
            alignContent: "center",
            gridAutoRows: "auto",
            height: "100%",
            width: "100%",
          }}
        >
          {Array.from({ length: 15 }).map((_, index) => {
            const productIndex = index % products.length;
            const product = products[productIndex];

            // figure out which column (0–4)
            const col = index % 5;

            let style = {};
            if (col === 0 || col === 4) {
              style = {
                width: windowSize.width < 640 ? "114px" : "156px", // mobile vs desktop
                height: windowSize.width < 640 ? "142px" : "195px",
                borderRadius: "18.47px",
              };
            } else if (col === 1 || col === 3) {
              style = {
                width: windowSize.width < 640 ? "114px" : "183px",
                height: windowSize.width < 640 ? "142px" : "229px",
                borderRadius: "21.69px",
              };
            } else if (col === 2) {
              style = {
                width: windowSize.width < 640 ? "114px" : "183px",
                height: windowSize.width < 640 ? "170px" : "229px",
                borderRadius: "21.69px",
              };
            }


            return (
              <div
                key={index}
                className="relative overflow-hidden opacity-20 shadow-md hover:shadow-xl transition-all duration-500"
                style={{
                  ...style,
                  margin: "auto", // center item in its grid cell
                }}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                  style={{ filter: "blur(2px) brightness(0.7)" }}
                />
              </div>
            );
          })}
        </div>

        {/* Main slider container - absolute in center */}
        <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center z-10">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`transition-all duration-700 ease-in-out w-full max-w-[221px] md:max-w-[355px] h-full max-h-[276px] md:max-h-[443px] ${index === currentSlide
                ? "opacity-100 scale-100 z-20"
                : "opacity-0 scale-90 absolute z-0"
                }`}
            >
              <div
                className="relative overflow-hidden shadow-2xl hover:scale-[1.02] transition-transform duration-500"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "42px",
                }}
              >
                {/* Desktop image */}
                <img
                  src={product.image}
                  alt={product.name}
                  className="hidden md:block w-full h-full object-cover"
                />

                {/* Mobile image */}
                <img
                  src={product.imageMobile || product.image}
                  alt={product.name}
                  className="block md:hidden w-full h-full object-cover"
                />

                {/* Button with exact specifications */}
                <a
                  href={product.link || "#"} // <-- add your link here
                  className="
                    absolute flex items-center justify-center 
                    bottom-[20px] md:left-[45%] left-[40%] -translate-x-1/2 
                    rounded-[76px] 
                    w-full 
                    max-w-[187px] md:max-w-[309px]
                    px-[50px] md:px-[78px] 
                    py-[6px] md:py-[12px] 
                    gap-[6px] 
                    bg-white
                    mx-[22px] opacity-85 md:opacity-100
                  "
                >
                  <span
                    className="
                      font-inter font-normal 
                      text-[14px] md:text-[16px] leading-[100%] 
                      tracking-[-0.03em] 
                      text-black text-center
                      group-hover:text-white
                    "
                  >
                    {/* Desktop text */}
                    <span className="hidden md:inline">Insecticides / AAGOR</span>

                    {/* Mobile text */}
                    <span className="inline md:hidden">Read More</span>
                  </span>
                </a>

              </div>
            </div>
          ))}
        </div>

        {/* Left navigation */}
        <div className="absolute left-7 md:left-[15%] lg:left-[25%] top-1/2 -translate-y-1/2 z-20">
          <button
            onClick={() => goToSlide("prev")}
            className="group relative flex items-center justify-center"
            aria-label="Previous slide"
          >
            <div className="bg-[#0000006E] backdrop-blur-sm hover:bg-[#0000006E]/30 text-white p-2 md:p-3 rounded-full transition-all hover:scale-110 shadow-lg">
              <svg
                className="w-4 h-4 md:w-8 md:h-8"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </div>
          </button>
        </div>

        {/* Right navigation */}
        <div className="absolute right-7 md:right-[15%] lg:right-[25%] top-1/2 -translate-y-1/2 z-20">
          <button
            onClick={() => goToSlide("next")}
            className="group relative flex items-center justify-center"
            aria-label="Next slide"
          >
            <div className="bg-[#0000006E] backdrop-blur-sm hover:bg-[#0000006E]/30 text-white p-2 md:p-3 rounded-full transition-all hover:scale-110 shadow-lg">
              <svg
                className="w-4 h-4 md:w-8 md:h-8"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 18l6-6-6-6" />
              </svg>
            </div>
          </button>
        </div>
      </div>

    </section>
  );
};

export default BestSelling;